export const CONTROL_CARD_BUTTON_TEXT = {
  SEND_REQUEST: 'Отправить заявку',
};
